import { FC, createElement } from 'react';
import { Alert, AlertIcon, AlertDescription, CloseButton, AlertProps, Heading, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { CbAnimationEnterExit } from '../../Animations';
const animationVariants = {
  transition: {
    duration: 0.5,
    ease: 'easeInOut'
  },
  variants: {
    enter: {
      height: 'auto'
    },
    leave: {
      height: 0
    },
    base: {
      height: 0
    }
  },
  initial: 'base',
  animate: 'enter',
  exit: 'leave'
};
const enterComp: FC<CbFormAlertProps> = ({
  content,
  animate,
  onClose,
  fontSize = 'lg',
  fontWeight = 'bold',
  borderless = true,
  ...props
}) => <motion.div style={{
  overflowY: 'hidden'
}} {...animationVariants} data-sentry-element="unknown" data-sentry-component="enterComp" data-sentry-source-file="CbFormAlert.tsx">
    <Alert status="error" borderWidth={borderless ? 0 : 1} backgroundColor="alert.error" position="relative" borderRadius={3} display="flex" paddingY={4} paddingX={6} {...props} data-sentry-element="Alert" data-sentry-source-file="CbFormAlert.tsx">
      <AlertIcon data-sentry-element="AlertIcon" data-sentry-source-file="CbFormAlert.tsx" />
      <AlertDescription fontSize={fontSize} fontWeight={fontWeight} color="text.secondary" paddingRight={onClose && '40px'} data-sentry-element="AlertDescription" data-sentry-source-file="CbFormAlert.tsx">
        <Flex flexDirection="column" fontSize="md" fontWeight="normal" color="cloud.900" data-sentry-element="Flex" data-sentry-source-file="CbFormAlert.tsx">
          <Heading size="md" data-sentry-element="Heading" data-sentry-source-file="CbFormAlert.tsx">{'Try Again'}</Heading>
          {content}
        </Flex>
      </AlertDescription>
      {onClose && <CloseButton color="cloud.900" position="absolute" right="8px" top="14px" onClick={onClose} />}
    </Alert>
  </motion.div>;
export interface CbFormAlertProps extends AlertProps {
  content?: string;
  animate: boolean;
  borderless?: boolean;
  onClose?: () => void;
}
export const CbFormAlert: FC<CbFormAlertProps> = props => {
  return <CbAnimationEnterExit animate={props?.animate} enterContent={createElement(enterComp, props)} data-sentry-element="CbAnimationEnterExit" data-sentry-component="CbFormAlert" data-sentry-source-file="CbFormAlert.tsx" />;
};